import { SvgIcon } from '@mui/material'

export const FeaturesIcon = () => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ width: '24px', height: '24px' }}
      fill="none"
    >
      <path
        fill="#1DB911"
        d="M12 2a10 10 0 1 0 10 10c0-1.16-.21-2.31-.61-3.39l-1.6 1.6c.14.59.21 1.19.21 1.79a8 8 0 1 1-8-8c.6 0 1.2.07 1.79.21L15.4 2.6C14.31 2.21 13.16 2 12 2Zm7 0-4 4v1.5l-2.55 2.55C12.3 10 12.15 10 12 10a2 2 0 1 0 2 2c0-.15 0-.3-.05-.45L16.5 9H18l4-4h-3V2Zm-7 4a6 6 0 1 0 6 6h-2a4 4 0 1 1-4-4V6Z"
      />
    </SvgIcon>
  )
}
